"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Docs = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Border_1 = require("./Border");
var Colors_1 = require("./Colors");
var Display_1 = require("./Display");
var Flex_1 = require("./Flex");
var SideBar_1 = require("./SideBar");
var Sizing_1 = require("./Sizing");
var Spacing_1 = require("./Spacing");
var Text_1 = require("./Text");
var Docs = function () { return (react_1.default.createElement("div", { className: "d-f" },
    react_1.default.createElement(SideBar_1.SideBar, null),
    react_1.default.createElement("div", { className: "bg-light1 d-f grow overflowx p6" },
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Border_1.Border, null), path: "border" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Colors_1.Colors, null), path: "colors" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Display_1.DisplayDoc, null), path: "display" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Flex_1.Flex, null), path: "flex" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Sizing_1.Sizing, null), path: "sizing" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Spacing_1.Spacing, null), path: "spacing" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Text_1.Text, null), path: "text" }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Colors_1.Colors, null), path: "" }))))); };
exports.Docs = Docs;
